import * as React from "react";
import PolizaEndorsementForm from "../polizaEndorsements/PolizaEndorsementForm";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { generateDefaultPoliza } from "../polizas/utils";
import { generateDefaultPolizaEndorsement } from "../polizaEndorsements/utils";

var EditPolizaEndorsementApp = function EditPolizaEndorsementApp(props) {
  var queryClient = new QueryClient();
  var poliza = props.poliza,
      poliza_endorsement = props.poliza_endorsement,
      endorsement_types = props.endorsement_types,
      cancel_reasons = props.cancel_reasons,
      beneficiario = props.beneficiario,
      contratante = props.contratante,
      asegurado = props.asegurado,
      itemAsegurado = props.itemAsegurado,
      payment_information = props.payment_information,
      commission = props.commission,
      companies = props.companies,
      regions = props.regions,
      communes = props.communes,
      _props$banks = props.banks,
      banks = _props$banks === void 0 ? [] : _props$banks,
      _props$insurance_brok = props.insurance_broker_agents,
      insurance_broker_agents = _props$insurance_brok === void 0 ? [] : _props$insurance_brok;
  var defaultPoliza = generateDefaultPoliza({
    poliza: poliza,
    beneficiario: beneficiario,
    contratante: contratante,
    asegurado: asegurado,
    itemAsegurado: itemAsegurado,
    payment_information: payment_information,
    commission: commission
  });
  var defaultPolizaEnforsement = generateDefaultPolizaEndorsement({
    polizaEndorsement: poliza_endorsement
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(PolizaEndorsementForm, {
    companies: companies,
    polizaEndorsement: defaultPolizaEnforsement,
    poliza: defaultPoliza,
    endorsement_types: endorsement_types,
    cancel_reasons: cancel_reasons,
    regions: regions,
    communes: communes,
    banks: banks,
    insuranceBrokerAgents: insurance_broker_agents,
    editMode: true
  })));
};

export default EditPolizaEndorsementApp;